"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentContext = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var crumb_nav_1 = __importDefault(require("../../../components/crumb_nav"));
var payment_details_1 = __importDefault(require("./payment-details"));
var update_credit_card_braintree_1 = __importDefault(require("./update-credit-card-braintree"));
var update_credit_card_failed_1 = __importDefault(require("./update-credit-card-failed"));
var update_credit_card_stripe_1 = __importDefault(require("./update-credit-card-stripe"));
exports.PaymentContext = (0, react_1.createContext)({});
exports.default = (function (_a) {
    var customerData = _a.customerData;
    if (!customerData) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // hardcoding payment gate to false for now until we figure out how this works with ProfitWell
    var paymentGated = false;
    var location = (0, react_router_dom_1.useLocation)();
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, react_1.useState)(customerData.first_name), 2), firstName = _b[0], setFirstName = _b[1];
    var _c = __read((0, react_1.useState)(customerData.last_name), 2), lastName = _c[0], setLastName = _c[1];
    var _d = __read((0, react_1.useState)(customerData.billing_company), 2), company = _d[0], setCompany = _d[1];
    var _e = __read((0, react_1.useState)(customerData.billing_phone), 2), phone = _e[0], setPhone = _e[1];
    var _f = __read((0, react_1.useState)(customerData.billing_address1), 2), address1 = _f[0], setAddress1 = _f[1];
    var _g = __read((0, react_1.useState)(customerData.billing_address2), 2), address2 = _g[0], setAddress2 = _g[1];
    var _h = __read((0, react_1.useState)(customerData.billing_city), 2), city = _h[0], setCity = _h[1];
    var _j = __read((0, react_1.useState)(customerData.billing_province), 2), province = _j[0], setProvince = _j[1];
    var _k = __read((0, react_1.useState)(customerData.billing_country), 2), country = _k[0], setCountry = _k[1];
    var _l = __read((0, react_1.useState)(customerData.billing_zip), 2), zip = _l[0], setZip = _l[1];
    var paymentInformation = customerData && customerData.payment_information;
    if (!paymentInformation) {
        return null;
    }
    // helper to create the breadcrumb header for payment section
    var buildCrumb = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            location.pathname.startsWith('/payment') && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("a", { onClick: function () { return history.replace('/payment'); } }, "Payment"))),
            location.pathname.startsWith('/payment/update-card') && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", null, " / "),
                react_1.default.createElement("a", { onClick: function () { return history.replace('/payment/update-card'); } }, "Update Card"))),
            location.pathname.startsWith('/payment/update-card/failed') && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", null, " / "),
                react_1.default.createElement("a", { onClick: function () { return history.replace('/payment/update-card/failed'); } }, "Failed")))));
    };
    var _m = window.accountApp, iconUrls = _m.iconUrls, settings = _m.settings;
    var cardBrand = paymentInformation.brand;
    var cardImage = (function () {
        if (!cardBrand)
            return '';
        // only lowercase the first letter and then use it as the key to reference iconUrls
        var cardBrandLowerCased = (cardBrand === null || cardBrand === void 0 ? void 0 : cardBrand.charAt(0).toLowerCase()) + cardBrand.slice(1);
        return iconUrls[cardBrandLowerCased];
    })();
    var contextValue = {
        customerData: customerData,
        activeCardImage: cardImage,
        paymentGated: paymentGated,
        firstName: firstName,
        lastName: lastName,
        company: company,
        phone: phone,
        address1: address1,
        address2: address2,
        city: city,
        province: province,
        country: country,
        zip: zip,
        paymentProcessor: settings.paymentProcessor,
        setFirstName: setFirstName,
        setLastName: setLastName,
        setCompany: setCompany,
        setPhone: setPhone,
        setAddress1: setAddress1,
        setAddress2: setAddress2,
        setCity: setCity,
        setProvince: setProvince,
        setCountry: setCountry,
        setZip: setZip,
    };
    var UpdatePayment = (function () {
        switch (settings.paymentProcessor) {
            case 'braintree':
                return update_credit_card_braintree_1.default;
            case 'stripe':
                return update_credit_card_stripe_1.default;
        }
    })();
    return (react_1.default.createElement(exports.PaymentContext.Provider, { value: contextValue },
        react_1.default.createElement(crumb_nav_1.default, { current: buildCrumb() }),
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/payment', component: payment_details_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/payment/update-card', component: UpdatePayment }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: '/payment/update-card/failed', component: update_credit_card_failed_1.default }))));
});
